import styled, {css, DefaultTheme} from 'styled-components'
import * as RTooltip from '@radix-ui/react-tooltip'
import {CSSProperties} from 'react'

type StyledTooltipProps = {
    $variant: 'light' | 'dark'
    $maxWidth?: CSSProperties['maxWidth']
}

export const StyledTooltipContent = styled(RTooltip.Content)<StyledTooltipProps>`
    ${({theme: {spacing, typography, shadows, zIndex}, $maxWidth}) => css`
        padding: ${spacing * 2}px ${spacing * 3}px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        box-shadow: ${shadows.lg};
        ${typography.textXs};
        font-weight: 500;
        z-index: ${zIndex.tooltip};
        max-width: ${$maxWidth ?? '90vw'};
        word-break: break-word;
    `}
    ${({$variant, theme}) => ColorStyles(theme)[$variant]};
`

const ColorStyles = ({palette}: DefaultTheme) => ({
    light: css`
        background: ${palette.neutral['25']};
        color: ${palette.neutral['700']};
        & svg {
            fill: ${palette.neutral.white};
        }
    `,
    dark: css`
        background: ${palette.neutral['950']};
        color: ${palette.neutral.white};
        & svg {
            fill: ${palette.neutral['950']};
        }
    `
})
